import React from "react";
import { withTranslation } from "react-i18next";
import { Typography, Col, Row } from "antd";
import { AimOutlined } from "@ant-design/icons";
import moment from "moment";
import { TextWithLabel } from "./TextWithLabel";
import WebsiteIcon from "../assets/svg/WebsiteIcon";
import PhoneIcon from "../assets/svg/PhoneIcon";
import { formatPhoneNumber } from "../utils/formaters";

const { Link, Text } = Typography;

const PatientProgramInfoComponent = ({ t, assistanceProgram, applicationStateJson, applicationId }) => {
  const { approvedDate, validThrough } = applicationStateJson || {};
  const {
    website,
    phone1,
    phone2,
    fax,
    phoneForRefills,
    address,
    name: assistanceProgramName
  } = assistanceProgram || {};

  const formatPhones = () => {
    const phones = [];
    if (phone1) phones.push(`${t("patient.general.phone1")}: ${formatPhoneNumber(phone1)}`);
    if (phone2) phones.push(`${t("patient.general.phone2")}: ${formatPhoneNumber(phone2)}`);
    if (fax) phones.push(`${t("patient.general.fax")}: ${formatPhoneNumber(fax)}`);

    return phones.join(", ");
  };

  return (
    <div style={{ padding: "0px 0px 0px 16px" }}>
      <Row>
        <Text strong style={{ paddingBottom: 8 }}>
          {t("patient.general.application_info")}
        </Text>
      </Row>
      <Row gutter={[32, 0]} justify="space-between">
        <Col>
          <TextWithLabel label={t("patient.general.assistance_program_name")} text={assistanceProgramName || "-"} />
          <TextWithLabel label={t("patient.general.application_id")} text={applicationId || "-"} />
          <TextWithLabel
            label={t("patient.general.approval_date")}
            text={approvedDate ? `${moment(approvedDate).utc().format("MM/DD/YYYY")}` : "-"}
          />
          <TextWithLabel
            label={t("patient.general.expiration_date")}
            text={validThrough ? `${moment(validThrough).utc().format("MM/DD/YYYY")}` : "-"}
          />
          <div style={{ padding: "6px 0px 8px 0px" }}>
            <Text style={{ color: "#9B9B9B" }}>{t("patient.general.program_website_label")}</Text>
            <div style={{ display: "flex", alignItems: "center", paddingTop: 10 }}>
              <WebsiteIcon />
              <Link style={{ paddingLeft: 6 }} href={website} target="_blank">
                {t("patient.general.program_website_link")}
              </Link>
            </div>
          </div>
          {(phone1 || phone2 || fax) && (
            <TextWithLabel
              label={t("patient.general.program_contact_label")}
              icon={<PhoneIcon />}
              text={formatPhones()}
              expandable={formatPhones().length > 20}
            />
          )}
          {phoneForRefills && phoneForRefills.trim() && (
            <TextWithLabel
              label={t("patient.general.program_phone_for_reffils_label")}
              icon={<PhoneIcon />}
              text={phoneForRefills.trim()}
              expandable={phoneForRefills.trim().length > 20}
            />
          )}
          {address && address.trim() && (
            <TextWithLabel
              label={t("patient.general.program_address_label")}
              icon={<AimOutlined style={{ fontSize: "20px" }} />}
              text={address.trim()}
              expandable={address.length > 20}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

const PatientProgramInfo = withTranslation()(PatientProgramInfoComponent);

export { PatientProgramInfo };
